// extracted by mini-css-extract-plugin
export default {"colocationColor":"#aa0061","developmentColor":"#e4002b","enterpriseColor":"#6e4180","pageContainer":"aI3FdrxMabb0cKnr6VpV"};